import { CreateOauthConnectionDto } from "@common/dto/oauth/create-oauth-connection.dto";
import { FinancialConnectionDto } from "@common/dto/financialAccount/financial-connection.dto";
import { FinancialConnectionWithAccounts } from "@common/types/financialConnection";
import {
    StripeExpressReturnTo,
    stripeExpressAccountLinkResponseSchema,
    stripeExpressRefreshCacheResponseSchema,
    StripeExpressAccountLinkResponse,
    StripeExpressRefreshCacheResponse,
} from "@common/schemas/domains/stripe/stripe-express.schema";
import { backendClient, unwrapResponse } from "./backendClient";

interface StripeExpressContext {
    returnTo: StripeExpressReturnTo;
    invoiceId?: string;
}

export async function createStripeExpressConnection(
    data: StripeExpressContext & { defaultEntityId: number },
): Promise<StripeExpressAccountLinkResponse> {
    return stripeExpressAccountLinkResponseSchema.parse(
        unwrapResponse(await backendClient.post("/stripe-express", data)),
    );
}

export async function remintStripeExpressAccountLink(
    connectionId: number,
    data: StripeExpressContext,
): Promise<StripeExpressAccountLinkResponse> {
    return stripeExpressAccountLinkResponseSchema.parse(
        unwrapResponse(
            await backendClient.post(
                `/stripe-express/${connectionId}/account-link`,
                data,
            ),
        ),
    );
}

export async function createStripeExpressLoginLink(
    connectionId: number,
): Promise<StripeExpressAccountLinkResponse> {
    return stripeExpressAccountLinkResponseSchema.parse(
        unwrapResponse(
            await backendClient.post(
                `/stripe-express/${connectionId}/login-link`,
                {},
            ),
        ),
    );
}

export async function refreshStripeExpressCache(
    connectionId: number,
): Promise<StripeExpressRefreshCacheResponse> {
    return stripeExpressRefreshCacheResponseSchema.parse(
        unwrapResponse(
            await backendClient.post(
                `/stripe-express/${connectionId}/refresh-cache`,
                {},
            ),
        ),
    );
}

export async function fixStripeConnection(
    id: number,
    data: CreateOauthConnectionDto,
): Promise<FinancialConnectionWithAccounts> {
    return FinancialConnectionDto.deserialize(
        unwrapResponse(
            await backendClient.post(`/stripe-connection/fix/${id}`, data),
        ),
    );
}
